/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["body{margin:0}#containerDiv[_ngcontent-%COMP%]{height:500px;width:400px;display:none}.ccp[_ngcontent-%COMP%]{width:320px;height:525px;box-shadow:1px 2px 3px rgba(0,0,0,.1);background-color:#fff}"];
export { styles as styles };
